"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _styles = require("../../shared/styles");
var _selectors = require("../../shared/styles/themes/selectors");
var _templateObject;
var _excluded = ["buttonType"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var getTypesProps = function getTypesProps(_ref) {
  var buttonType = _ref.buttonType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var typesProps = {
    link: {
      background: 'transparent',
      color: (0, _selectors.color)(rest),
      borderWidth: '0',
      borderColor: 'transparent',
      hoverColor: _styles.color.azure,
      ripple: 'transparent',
      customCss: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        text-decoration: underline;\n        text-transform: none;\n      "])))
    },
    transparent: {
      background: 'transparent',
      color: (0, _selectors.color)(rest),
      rippre: (0, _selectors.color)(rest),
      borderWidth: '0',
      borderColor: 'transparent'
    }
  };
  return typesProps[buttonType] || {};
};
var _default = exports["default"] = getTypesProps;